export const COPY_TRACK = "copyTrack";

export const CORRECT_START_TIME = "correctStartTime";

export const SEGMENTATION_TRACK = "segmentationTrack";

export const APPEND_TRACK_TO_FILTER_EFFECT_GROUP = "appendTrackToFilterEffectGroup";

export const INSERT_NEW_FILTER_EFFECT_GROUP = "insterNewFilterEffectGroup";

export const REMOVE_FILTER_EFFECT_TRACK = "removeFilterEffectTrack";

export const CORRECTION_GROUP_START_TIME_FROM_SDK = "correctionGroupStartTimeFromSDK";

export const CORRECTION_GROUP_ZINDEX_FROM_SDK = "correctionGroupZindexFromSDK";

export const CHANGE_FILTER_EFFECT_DRAG_START_TIME = "ChangeFilterEffectDragStartTime";

export const CHANGE_FILTER_EFFECT_GROUP_ITEM_PROPERTY = "ChangeFilterEffectGroupItemProperty";

export const CHANGE_FILTER_EFFECT = "ChangeFilterEffect";

export const INSERT_FILTER_EFFECT_GROUP = "insert_Filter_Effect_Group";

export const INSERT_FILTER_EFFECT_TRACK_TO_GROUP = "insert_Filter_Effect_TrackToGroup";

export const ADD_FILTER_EFFECT_GROUP = "Add_Filter_Effect_Group";

export const ADD_PIP_STICKER_TEXT_GROUP = "addPip_Sticker_Text_Group";

export const CLEAR_LINE = "clearLine";

export const CLEAR_FILTER_EFFECT_LINE = "clearFilterEffectLine";

export const CHANGE_TEXT_BUBBLE = "changeTextBubble";

export const REMOVE_TRACK = "removeTrack";

export const CHANGE_STICKER = "changeSticker";

export const CHANGE_TRACK_DRAG_PROPS = "changTrackDragProps";

export const CHANGE_EDIT_WINDOW = "changeEditWindow";

export const CHANGE_EDIT_WINDOW_DATA = "changeEditWindowData";

export const INSERTION_NEW_GROUP = "insertionNewGroup";

export const INSERTION_NEW_FILTER_EFFECT_GROUP = "insertionNewFilterEffectGroup";

export const CHANGE = "Change";

export const CHANGE_FILTER_EFFECT_CURRENT_TRACK = "ChangeFilterEffectCurrentTrack";

export const ADD_GROUP = "AddGroup";

export const CHANGE_CURRENT_DRAG_ITEM = "ChangeCurrentDragItem";

export const UPDATE = "Update";

export const CHANGE_CURRENT_TRACK = "ChangeCurrentTrack";

export const CHANGE_IS_MOVE_TIME_LINE_STATUS = "ChangeIsMoveTimeLineStatus";

export const CHANGE_DRAG_START_TIME = "ChangeDragStartTime";

export const APPEND_TRACK_TO_GROUP = "AppendTrackToGroup";

export const CHANGE_MAX_DURATION = "ChangeMaxDuration";

export const CHANGE_CURRENT_TIME = "ChangeCurrentTime";

export const CHANGE_FILTER_EFFECT_DRAG_DURATION = "ChangeFilterEffectDragDuration";

export const CHANGE_DRAG_DURATION = "ChangeDragDuration";

export const CHANGE_GROUP_TO_BOTTOM_BOUNDARY = "ChangeGroupToBottomboundary";

export const CHANGE_TRACK_MANAGER_PROPERTY = "ChangeProperty";

export const MERGE_TRACK_MANAGER_PROPERTY = "mergeProperty";

export const CHANGE_GROUP_ITEM_PROPERTY = "ChangeGroupItemProperty";

export const CHANGE_GROUP_TO_TOP_BOUNDARY = "ChangeGroupToTopBoundary";

export const INSERT_NEW_TRACK_TO_GROUP = "insertNewTrackToGroup";

export const UPDATE_CURRENT_DRAG_ITEM = "updateCurrentDragItem";

export const CHANGE_FILTER_EFFECT_CURRENT_DRAG_ITEM = "ChangeFilterEffectCurrentDragItem";

export const CHANGE_TRACK_LIST_ITEM = "changeTrackListItem";

export const CHANGE_POSITION = "changePosition";

export const REMOVE_MAIN_TRACK = "removeMainTrack";

export const CHANGE_MAIN_TRACK_PROPERTY = "changeProperty";

export const CHANGE_TRACK_LIST_PROPERTY = "changeTrackListProperty";

export const CHANGE_TRACK_LIST_ITEM_POSITION = "changeTrackListItemPosition";

export const MAIN_TRACK_APPEND_ITEM = "mainTrackAppendItem";

export const APPEND_TRACK_LIST_ITEM = "appendTrackListItem";

export const APPEND_SPECIAL_EFFECTS_LIST_ITEM = "appendSpecialEffectsListItem";

export const CHANGE_CUT_TO_DRAG_PROPS = "changCutToDragProps";

export const FINDE_CAN_ADD_CUT_TO = "findeCanAddCutTo";

export const ADD_CUT_TO = "addCutTo";

export const CORRECT_POSITION = "correctPosition";

export const CHANGE_MAIN_GROUP_MAX_DURATION = "changeMainGroupMaxDuration";

export const ADD_BACKGROUND = "addBackground";

export const CHANGE_CHOOSE_LIST_MANAGER_PROPERTY = "ChangeChooseListManagerProperty";

export const UPDATE_MAIN_TRACK_DURATION = "updateMainTrackDuration";

export const ADD_LOCAL_FILE = "addLocalFile";
//存储视频比例

export const UPDATE_PROPORTION = "updateProportion";






